import { Component, AfterViewInit, ElementRef, ViewChild, Inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { gsap } from 'gsap';
import { CSSPlugin } from 'gsap/all';
import { ApiClientService } from '../../services/api-client.service';
import { firstValueFrom } from 'rxjs';

let newsletterPluginsRegistered = false;

@Component({
  selector: 'app-newsletter',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './newsletter.component.html',
  styleUrl: './newsletter.component.scss'
})
export class NewsletterComponent implements AfterViewInit {
  @ViewChild('newsletterSection', { static: true }) newsletterSection!: ElementRef<HTMLElement>;

  private readonly isBrowser: boolean;

  email = '';
  loading = false;
  success = false;
  error = '';

  constructor(
    @Inject(PLATFORM_ID) platformId: Object,
    private readonly api: ApiClientService,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);

    if (this.isBrowser && !newsletterPluginsRegistered) {
      gsap.registerPlugin(CSSPlugin);
      newsletterPluginsRegistered = true;
    }
  }

  ngAfterViewInit(): void {
    if (!this.isBrowser) {
      return;
    }
    if (window.innerWidth <= 768) {
      return;
    }

    gsap.from(this.newsletterSection.nativeElement, {
      y: 60,
      opacity: 0,
      duration: 1,
      ease: 'power2.out'
    });
  }

  async onSubmit(): Promise<void> {
    if (!this.isBrowser) return;

    if (!this.email || !this.validateEmail(this.email)) {
      this.error = 'Please enter a valid email address';
      return;
    }

    this.loading = true;
    this.error = '';
    this.success = false;

    try {
      await firstValueFrom(
        this.api.post('/newsletter/subscribe', { email: this.email.trim().toLowerCase() })
      );

      this.success = true;
      this.email = '';

      gsap.fromTo(
        '.success-message',
        { scale: 0.8, opacity: 0 },
        { scale: 1, opacity: 1, duration: 0.5, ease: 'back.out(1.7)' }
      );
    } catch (err) {
      this.error = err instanceof Error ? err.message : 'Something went wrong. Please try again.';
    } finally {
      this.loading = false;
    }
  }

  validateEmail(email: string): boolean {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }
}
